import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSupervisor = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "supervisor_account_24px",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon/action/supervisor_account_24px",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM4.77 17H9.05C9.02 17.16 9 17.33 9 17.5V19H2V17.5C2 15.17 6.66 14 9 14C9.56 14 10.25 14.07 10.98 14.2C10.27 14.68 9.68 15.28 9.34 16.01C9.28502 16.01 9.22755 16.0075 9.17007 16.005L9.17 16.005L9.16993 16.005C9.11245 16.0025 9.05498 16 9 16C7.47 16 5.76 16.5 4.77 17ZM16.5 14.5C14.66 14.5 11 15.51 11 17.5V19H22V17.5C22 15.51 18.34 14.5 16.5 14.5ZM19 10.5C19 11.44 18.47 12.25 17.71 12.68C17.35 12.88 16.94 13 16.5 13C16.06 13 15.65 12.88 15.29 12.68C14.53 12.25 14 11.44 14 10.5C14 9.12 15.12 8 16.5 8C17.88 8 19 9.12 19 10.5Z",
			fill: "#2771bb"
		})
	})]
});
const ForwardRef = forwardRef(SvgSupervisor);
export default ForwardRef;
